import { Message } from 'element-ui';

/**
 * 过滤订单表格数据
 * @param {Array} data - 原始数据
 * @param {string} searchText - 搜索文本
 * @returns {Array} 过滤后的数据
 */
export const filterTreeData = (data, searchText) => {
    return data.filter(item => {
        const match = item.orderNo.toLowerCase().includes(searchText);
        if (item.childList && item.childList.length) {
            const filteredChildren = filterTreeData(item.childList, searchText);
            if (filteredChildren.length) {
                item.childList = filteredChildren;
                return true;
            }
            return match;
        }
        return match;
    });
};

/**
 * 查找第一个匹配项
 * @param {Array} data - 过滤后的数据
 * @param {string} searchText - 搜索文本
 * @returns {Object} 包含第一个匹配项和父节点的对象
 */
export const findSingleMatch = (data, searchText) => {
    const findFirstMatch = (items, parent = null) => {
        for (let i = 0; i < items.length; i++) {
            if (items[i].orderNo.toLowerCase().includes(searchText)) {
                return { singleMatch: items[i], parentNode: parent };
            }
            if (items[i].childList && items[i].childList.length) {
                const result = findFirstMatch(items[i].childList, items[i]);
                if (result.singleMatch) {
                    return result;
                }
            }
        }
        return { singleMatch: null, parentNode: null };
    };

    return findFirstMatch(data);
};

const flag = {
    '0': '成功',
    '1': '失败'
};

/**
 * 格式化打印日志数据
 * @param {Array} data - 原始日志数据
 * @param {Object} dictData - 字典数据
 * @returns {Array} 格式化后的日志数据
 */
export const formatLogData = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(item => {
        item.operationResult = flag[item.operationResult] || '';
        item.fenceDistanceKm = item.fenceDistanceKm ? `${item.fenceDistanceKm}KM` : '-';
        item.picList && item.picList.forEach(pic => {
            pic.objTypeName = dictData.OPERATION_LOG_ATTACHMENT_TYPE[pic.objType] || '';
        });
    });
    return data;
};

/**
 * 将字典数据格式化为{node: 'xx', id: 'xx'}形式，并按id从小到大排序
 * @param {Object} dictData 字典数据
 * @returns {Array} [{ node: 'xx', id: 'xx' }, { node: 'xx', id: 'xx' }]
 */
export const formatDictDataToNodeId = dictData => {
    return Object.entries(dictData)
        .map(v => ({ node: v[1], id: v[0] }))
        .sort((a, b) => Number(a.id) - Number(b.id));
};

/**
 * 复制文本到剪贴板
 * @param {string} txt - 要复制的文本
 * @returns {void}
 */
export const copyToClip = (txt) => {
    const input = document.createElement('input');
    input.setAttribute('value', txt);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    Message.success(`'${input.value}'复制成功`);
};